<div
    class="w-full divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm dark:divide-white/10 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10">
    <!-- <div (click)="collapsed.set(!collapsed())" class="flex space-x-3 p-2 hover:cursor-pointer">
        <div class="shrink-0 size-10 flex items-center justify-center">
            @if (question.type === 'do') {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-6 text-emerald-400">
                <path d="M20 6 9 17l-5-5" />
            </svg>
            } @else {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-6 text-red-400">
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
            </svg>
            }
        </div>
        <div class="min-w-0 flex-1">
            <div class="flex flex-row w-full items-center justify-start gap-x-2">
                @if (question.type === 'do') {
                <span
                    class="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 inset-ring inset-ring-green-600/20 dark:bg-green-400/10 dark:text-green-400 dark:inset-ring-green-500/20">Do</span>
                } @else {
                <span
                    class="inline-flex items-center rounded-full bg-red-50 px-2 py-1 text-xs font-medium text-red-700 inset-ring inset-ring-red-600/20 dark:bg-red-400/10 dark:text-red-400 dark:inset-ring-red-500/20">Don't</span>
                }


                @if (question.generalised) {
                <span
                    class="inline-flex items-center rounded-full bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 inset-ring inset-ring-yellow-600/20 dark:bg-yellow-400/10 dark:text-yellow-500 dark:inset-ring-yellow-400/20">Context Required</span>
                } @else {
                <span
                    class="inline-flex items-center rounded-full bg-primary/10 px-2 py-1 text-xs font-medium text-accent inset-ring inset-ring-primary/25 dark:bg-primary/15 dark:inset-ring-primary/35">Configured</span>
                }
            </div>
            <p class="text-sm text-primary mt-1">
                {{ question.statement }}
            </p>
        </div>
        <div class="flex shrink-0 self-center h-full items-center justify-center text-primary hover:cursor-pointer">
            @if (collapsed()) {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-5 text-primary">
                <path d="m6 9 6 6 6-6" />
            </svg>
            } @else {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-5 text-primary">
                <path d="m18 15-6-6-6 6" />
            </svg>
            }
        </div>
    </div> -->

    <div (click)="collapsed.set(!collapsed())" class="flex space-x-3 p-2 hover:cursor-pointer">
        <div class="shrink-0 size-10 flex items-center justify-center">
            @if (question.type === 'do') {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-6 text-emerald-400">
                <path d="M20 6 9 17l-5-5" />
            </svg>
            } @else {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-6 text-red-400">
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
            </svg>
            }
        </div>
        <div class="min-w-0 flex-1">
            <p class="text-sm text-primary font-semibold">
                {{ question.statement }}
            </p>
            <div class="flex flex-row w-full items-center justify-start gap-x-2 mt-1">
                @if (question.type === 'do') {
                <span
                    class="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 inset-ring inset-ring-green-600/20 dark:bg-green-400/10 dark:text-green-400 dark:inset-ring-green-500/20">Do requirement</span>
                } @else {
                <span
                    class="inline-flex items-center rounded-full bg-red-50 px-2 py-1 text-xs font-medium text-red-700 inset-ring inset-ring-red-600/20 dark:bg-red-400/10 dark:text-red-400 dark:inset-ring-red-500/20">Don't requirement</span>
                }

            </div>
        </div>
        <div
            class="flex flex-row gap-x-2 shrink-0 self-center h-full items-center justify-end text-primary hover:cursor-pointer">

            @if (question.generalised) {
            <span
                class="inline-flex items-center rounded-full bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 inset-ring inset-ring-yellow-600/20 dark:bg-yellow-400/10 dark:text-yellow-500 dark:inset-ring-yellow-400/20">Context
                Required</span>
            } 
            <!-- @else {
            <span
                class="inline-flex items-center rounded-full bg-primary/10 px-2 py-1 text-xs font-medium text-accent inset-ring inset-ring-primary/25 dark:bg-primary/15 dark:inset-ring-primary/35">Configured</span>
            } -->

            <button type="button" class="fab-button-secondary text-secondary">
                @if (collapsed()) {
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m6 9 6 6 6-6" />
                </svg>
                } @else {
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m18 15-6-6-6 6" />
                </svg>
                }
            </button>
        </div>
    </div>

    @if (!collapsed() && question.generalised) {
    <div class="p-2 flex flex-col gap-y-2">
        <div class="w-full flex flex-row items-center justify-between">
            <div class="inline-flex items-center gap-x-1.5 text-sm text-primary font-bold">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 text-red-500">
                    <path d="M18 6 6 18" />
                    <path d="m6 6 12 12" />
                </svg>
                Zero Tolerance
            </div>

            <div class="inline-flex items-center gap-x-1.5 text-sm text-primary font-bold">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 text-green-500">
                    <path d="M20 6 9 17l-5-5" />
                </svg>
                Most Tolerant
            </div>
        </div>

        @if (enrichments()?.length) {
        <div class="flex flex-row items-center justify-between w-full gap-x-6 px-4">
            <mat-slider class="my-material-slider-theme flex-1 mx-4" [min]="0" [max]="enrichmentSliderMax" [step]="1"
                [discrete]="true" [showTickMarks]="true">
                <input matSliderThumb [value]="selectedEnrichmentIndex()"
                    (valueChange)="onEnrichmentSliderChange($event)">
            </mat-slider>
        </div>

        <!-- Selected Enrichment -->
        @if (selectedEnrichment(); as enrichment) {
        <div class="rounded-xl bg-gray-50 p-3 dark:bg-gray-800/50">
            <div class="inline-flex gap-x-2 items-center justify-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-4 text-gray-500">
                    <path
                        d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915" />
                    <circle cx="12" cy="12" r="3" />
                </svg>
                <p class="text-sm text-secondary">Selected tolerance level:</p>
            </div>
            @if (enrichment.enrichment_text) {
            <p class="mt-1 text-sm text-primary">{{ enrichment.enrichment_text }}</p>
            } @else {
            <p class="mt-1 text-sm text-primary">No enrichment selected</p>
            }
        </div>
        }
        <!-- Selected Enrichment - END -->
        }
    </div>
    } @else if (!collapsed() && !question.generalised) {
    <div class="p-2 flex flex-col gap-y-2">
        <div class="rounded-xl bg-gray-50 p-3 dark:bg-gray-800/50">
            <div class="inline-flex gap-x-2 items-center justify-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-4 text-emerald-500">
                    <path
                        d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                    <circle cx="12" cy="12" r="4" />
                </svg>
                <p class="text-sm text-secondary">Question configured</p>
            </div>
            <p class="mt-1 text-sm text-primary">This question offers enough specifity for the AI to test against.</p>
        </div>
    </div>
    }
</div>